import { render, staticRenderFns } from "./index_Inbox.vue?vue&type=template&id=f1750446&scoped=true&"
import script from "./index_Inbox.vue?vue&type=script&lang=js&"
export * from "./index_Inbox.vue?vue&type=script&lang=js&"
import style0 from "./index_Inbox.vue?vue&type=style&index=0&id=f1750446&prod&scoped=true&lang=css&"
import style1 from "./index_Inbox.vue?vue&type=style&index=1&id=f1750446&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1750446",
  null
  
)

export default component.exports